import ambulanceImage from '../Images/AmbulanceService.jpg';
import ipmImage from '../Images/ipm.png';
import falconImage from '../Images/falcon.png';
import nasaInstaImage from '../Images/nasa-insta.webp';
import workReportImage from '../Images/work-report.png';
import madPigeonImage from '../Images/mad-pigeon.jpg';
import yahachhaImage from '../Images/yaha-chha.png';

export const projects = [
    {
        img: yahachhaImage,
        name: "YahaChha - Freelance Marketplace",
        desc: `It was my first project at Rootdevs. Joined just before launch and took over most of the
                backend work, helping ship a stable product on time by fixing critical issues and completing pending
                features. Built key parts of the system including KYC and VAT flows, payment withdrawal system, talent
                ranking (boost/category/location), and a daily bid limit to reduce spam. Also worked on analytics for
                profile views, clicks, and proposals, along with invoicing and blog features. Currently handling new
                features, production issues, and supporting other developers to keep things running smoothly.`,
        technologies: ["TypeScript", "Node.js", "Prisma", "MySQL", "Redis", "RabbitMQ"],
        features: [],
        links: {
            "web app": "https://yahachha.com",
            "Android app": "https://play.google.com/store/apps/details?id=com.yahachha.jobs&pcampaignid=web_share",
            "IOS app": "https://apps.apple.com/us/app/yaha-chha-work-hire/id6751456932"
        }
    },
    {
        img: ambulanceImage,
        name: "HealthFleet Ambulance Service",
        desc: "I was team lead of this project at Core Devs Ltd. I did the full backend, mobile app and created only reusable modules for the frontend. The platform allows local ambulance companies to list their services on the platform. When a service is requested, the drivers receive real-time notifications with the patient's location. The main features were super admin dashboard, admin dashboard, mobile app for Drivers, google maps and automated trip scheduling.",
        features: [],
        technologies: ["Node.js", "express.js", "socket.io", "mongoDB", "orama search", "google maps api", "react native", "expo"],
        links: {
            "Case study": "https://coredevsltd.com/CaseStudy/HealthFleetAmbulanceService",
            "Web app video": "https://drive.google.com/file/d/12V5M7MZn-WVgun0rSTxsNypaWv0BR6QB/view?usp=sharing",
            "Mobile app video": "https://drive.google.com/file/d/1Pm2s1Okhpz8lhZj1_2rI_HhBI80-Madc/view"
        }
    },
    {
        img: ipmImage,
        name: 'IPM',
        desc: "At Core Devs Ltd the CRO team bids on projects at upwork. Tracking their activity with the regular monitoring tools was not enough for the managers. Then the managers created some bots to pull jobs from upwork through scrapping and api. Then they streamlined those to my server. I built that server to receive the projects in real-time and notify the CRO team members through a web platform. The team then started bidding on projects through my tool. This activity generates data about who is bidding on what, when they bid, how long it took, and whether they bid late. I provided stats and reports in the web app based on this data. From then on, managers could easily monitor the CRO team with a bird's-eye view of their activity, leading to better performance and more projects. Other features included taking breaks, comments and mentioning users inside projects, user management, and push notifications.",
        features: [],
        technologies: ["Node.js", "express.js", "socketIO", "mongoDB", "nginx"],
        links: {
            "Web app": "https://jobs.coredevs.ltd"
        }
    },
    {
        img: falconImage,
        name: 'Falcon Boilerplate',
        desc: "I made this to build the backend faster and in an organized way. The benefit of using this boilerplate is that I don't have to worry about startup tasks. I only need to write the logic of different services. There are some useful tools and hooks, such as handling graceful shutdown procedures and logging server errors with client inputs to a specific file while in production so that I can figure out problems easily and the console stays clean. There are more crazy features.",
        features: [
            "You only need to write the logic for your services.",
            "It is quite easy to inject a new tool/hook/etc that will be accessible to all entities.",
            "Docker Compose files are available for both development and production.",
            "Error logs can be traced with a reference ID."
        ],
        technologies: [
            'Node js',
            'express.js',
            'socket.io',
            'prisma',
            'postgresql'
        ],
        links: {
            'Github repo': 'https://github.com/jayeen28/falcon-boilerplate'
        }
    },
    {
        img: nasaInstaImage,
        name: 'NASA-INSTA',
        desc: ' It will post the astronomy picture of the day from NASA to a specific instagram account everyday.',
        features: [
            'Everyday it will take the image, title and description from the NASA api.',
            'If instagram sends verification code then it will get the code by logging in to gmail account.',
            'If instagram gives any challenge then it will solve the challenge for logging in to the instagram account.',
        ],
        technologies: [
            'Node.js',
            'instagram-web-api',
            'puppeteer'
        ],
        links: {
            'Github repo': 'https://github.com/jayeen28/NASA-INSTA',
            'Instagram account': 'https://www.instagram.com/nasa_picture_of_the_day/'
        }
    },
    {
        img: workReportImage,
        name: 'Work report generator',
        desc: 'I am tired of making work reports daily at the office. That’s why I made this.',
        features: [
            'Make project basis work reports with a single command',
            'Auto generated pdf will be the output of the command.',
            'Pdf is generated from html so that it can be customized easily.',
        ],
        technologies: [
            'NodeJs',
            'puppeteer'
        ],
        links: {
            'Github repo': 'https://github.com/jayeen28/reportgen-CLI',
        }
    },
    {
        img: madPigeonImage,
        name: 'MAD PIGEON',
        desc: 'Custom discord bot',
        features: [
            'Opensea NFT floor price alert. The bot sends alerts via dm.',
            'Leaderboard system by tracking the user’s activity(message,reaction).',
            'The bot is instructed to track a specific voice channel to know how long a user has stayed on that channel.',
            'The bot also counts how many users have joined the server from a specific user’s invite link.',
            'The bot saves the information in a mongodb database and it continuously posts a leaderboard update on a specific channel every one hour. There is also a command(/leaderboard) to see the leaderboard update anytime.',
            'There is a leveling system. By achieving a certain amount of points the user’s level upgrade. When a user is upgraded or downgraded to a level he/she gets a dm by the bot.',
            'The bot also can play music in a voice channel.'
        ],
        technologies: [
            'NodeJs',
            'MongoDB',
            'DiscordJs',
            'Opensea-js',
            'Ytdl-core',
            'DiscordJs/voice'
        ],
        links: {
            'Github repo': 'https://github.com/jayeen28/MAD-PIGEON',
        }
    }
]